import { useQuery } from "@tanstack/react-query";

import { fetchReleaseFolders } from "./release-folders.api";

export const useReleaseFolders = (workspaceVersionId: number | null) =>
  useQuery({
    queryKey: ["releaseFolders", workspaceVersionId],
    queryFn: () => fetchReleaseFolders(workspaceVersionId!),
    enabled: !!workspaceVersionId,
  });
